/**
 * @fileoverview Inicializador do sistema híbrido mobile/desktop
 * Força ativação dos sistemas de autenticação e dados para mobile
 * @module HybridInit
 */

import authManager from './mobileAuth.js';

/**
 * Inicializa sistema híbrido
 */
function initHybridSystem() {
  const isMobile = /Mobile|Android|iPhone|iPad/.test(navigator.userAgent);
  
  console.log('🔧 [HYBRID] Inicializando sistema híbrido...');
  console.log('📱 [HYBRID] Mobile detectado:', isMobile);
  
  if (isMobile) {
    // Força inicialização do authManager
    authManager.init();
    
    // Inicia monitoramento de sessão se houver tokens
    const tokens = authManager.getTokens();
    if (tokens?.access) {
      console.log('🔑 [HYBRID] Tokens encontrados, iniciando monitor');
      import('./sessionMonitor.js').then(({ default: sessionMonitor }) => {
        sessionMonitor.start();
      });
    }
    
    console.log('✅ [HYBRID] Sistema mobile ativado');
  } else {
    console.log('🖥️ [HYBRID] Sistema desktop ativo');
  }
}

// Auto-inicialização
initHybridSystem();

export default { initHybridSystem };